export function getRoute(path: string, parameter: string): string {
  return `${path}/${parameter}`;
}

export function getRouteWithSearchParameter(path: string, searchCode: string, searchValue: string): string {
  return `${path}?${searchCode}=${searchValue}`;
}
